import React, { useCallback, useRef, useState } from "react";
import {
  Badge,
  BlockStack,
  Box,
  Card,
  InlineStack,
  Page,
  SkeletonBodyText,
  SkeletonDisplayText,
  Toast,
  Layout,
} from "@shopify/polaris";
import Item from "./Item";
import "./index.css";
import PremiumItem from "./PremiumItem";
import SourcingQuotaList from "./SourcingQuotaList";
import ImportQuotaList from "./ImportQuotaList";
import FeatureList from "./FeatureList";
import QuestionBox from "./QuestionBox";
import {
  reqGetCurrentStoreInfo,
  reqGetNewSubscribeList,
  reqPostNewSubscribeAdd,
  reqPostNewSubscribeChange,
} from "../../../../api";
import AdditionalBenefitsModal from "./AdditionalBenefitsModal";
import FeedbackOptionModal from "./FeedbackOptionModal";
import PersonalAgentModal from "./PersonalAgentModal";
import ReminderPlanModal from "./ReminderPlanModal";
import { useEffect } from "react";
import { store } from "../../../../store";
import { changePersonLevel, setInitialPath } from "../../../../slice";
import SearchLoading from "../../../../components/SearchLoading";
import defalutData from "./subData";
import {  useLocation } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
import DowngradePlanModal from "./DowngradePlanModal";
const SubscriptionPaidClass = ({handleModalCallback,handleDifferentModalOpen,refData}) => {
  const shopify = window.shopify;
  const [initPage, setInitPage] = useState(true); //页面初始化
  const [pageLoading, setPageLoading] = useState(false); // 页面加载中
  const [planShow, setPlanShow] = useState(true);
  const [billPlan, setBillPlan] = useState(false); //真实类型套餐
  const shopify_level = useSelector(
    (state) => state.languageReducer.subScriptData.shopify_level
  );
  const shopifyLevel = () => {
    let flag = true;
    if (
      shopify_level === "Development" ||
      shopify_level === "Developer Preview" ||
      shopify_level === "staff" ||
      shopify_level === "staff_business"
    ) {
      flag = false;
    }
    return flag;
  };
  const [isClock,setIsClock] = useState({
    month_array:[0,0,0,0,0,0],
    year_array:[0,0,0,0,0,0]
  })
  // 向下展开权益
  const [featureStep,setFeatureStep] = useState({
    step1:0,
    step2:0,
    step4:0
  })
  const [activeIndex, setActiveIndex] = useState(0);
  const [optionWidth, setOptionWidth] = useState(0);
  const optionRef = useRef(null);
  const [subList, setSubList] = useState(defalutData.subList); // 套餐列表
  const [sourcingQuotaList, setSourcingQuotaList] = useState(sourcingRecharge); // sourcing量加量包
  const [importQuotaList, setImportQuotaList] = useState(importRecharge); // 导入量加量包
  const [currentPlanId, setCurrentPlanId] = useState(0); // 当前选中的套餐
  // 高级套餐
  const [premiumData, setPremiumData] = useState({
    open: false,
    agent_list: [],
  });
  const handlePremiumOff = () => {
    setPremiumData((prevValue) => ({
      ...prevValue,
      open: false,
    }));
  };
  const [downgradeReminde, setDowngradeReminde] = useState({
    open: false,
    plan: 0,
    needDown: 0,
    isHeight: true,
    bill_next_time: 0,
  }); // 套餐降级数据
  const [reminderModal, setReminderModal] = useState(false); //组合套餐更换
  const [feedOptionModal, setFeedOptionModal] = useState(false); // 首购大礼包
  const handleFeed = () => {
    setFeedOptionModal(true);
  };
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const handleOpenModal = () => {
    setUpgradeOpen(true);
  };
  const initialPath = useSelector((state) => state.languageReducer.initialPath);
  const enhancePackageList = (
    list,
    currentPlanId,
    pricingData,
    trialDays,
    agentList,
    firstPurchase,
    isZt,
    bill_glasses_level
  ) =>
    list.map((item) => {
      const priceInfo = pricingData.find((p) => p.key === item.id) || {};
      const isCurrentPlan = item.id === currentPlanId;
      const isAnnualPlan = priceInfo?.is_yearly === 1;
      let button = "";
      let disabled = false;
      if (bill_glasses_level === 1) {
        // 当前为年套餐页
        if (isAnnualPlan) {
          if (isCurrentPlan) {
            // 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          }
        }
      } else {
        if (isAnnualPlan) {
          if (isCurrentPlan) {
            // 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else if (trialDays !== 0 && item.id !== 4) {
              button = `Start ${trialDays}-day free trial`;
            } else {
              button = "Select Plan";
            }
          } else if (item.id === 0 && item.id !== currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        }
      }

      return {
        ...item,
        ...priceInfo,
        first_purchase: firstPurchase,
        is_zt: isZt,
        bill_level: currentPlanId,
        agent: item.id === 5 ? agentList : [],
        button,
        disabled,
        loading: false,
      };
    });
  // 获取套餐数据
  const getSubscribeList = async () => {
    try {
      let res = await reqGetNewSubscribeList();
      if (res.code === "200") {
        const {
          bill_level,
          trial_days,
          agent_list,
          one_package,
          first_purchase,
          is_zt,
          bill_glasses_level,
          bill_next_time,
        } = res.data;
        setDowngradeReminde((prev) => ({
          ...prev,
          plan: bill_level,
          bill_next_time,
        }));
        setPremiumData((prevValue) => ({
          ...prevValue,
          agent_list: res.data.agent_list,
        }));
        setPlanShow(
          bill_glasses_level === 1 || bill_level === 0 ? false : true
        );
        setActiveIndex(bill_glasses_level === 1 || bill_level === 0 ? 1 : 0)
        let packageData = res.data.package;
        setIsClock((prev)=>({
          ...prev,
          month_array:packageData.month_array,
          year_array:packageData.year_array
      }))
        setBillPlan(bill_glasses_level === 1 ? true : false);
        setCurrentPlanId(bill_level);
        // 仅高级套餐有折扣不展示闹钟
        
        // 处理月套餐
        const enhancedMonth = enhancePackageList(
          subList.month,
          bill_level,
          packageData.month,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          bill_glasses_level
        );
        // 处理年套餐
        const enhancedYear = enhancePackageList(
          subList.year,
          bill_level,
          packageData.year,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          bill_glasses_level
        );

        setSubList((prev) => ({
          ...prev,
          month: enhancedMonth,
          year: enhancedYear,
        }));

        // sourcing加量包
        let sourcingList = sourcingQuotaList.map((item, ind) => {
          return {
            ...item,
            ...one_package.sourcing[ind],
          };
        });
        setSourcingQuotaList(sourcingList);

        // 导入加量包
        let importList = importQuotaList.map((item, ind) => {
          return {
            ...item,
            ...one_package.import[ind],
          };
        });
        setPageLoading(false);
        setInitPage(false);
        setImportQuotaList(importList);
        setTimeout(() => {
          handRefCurrent();
        }, 100);
      }
    } catch (error) {}
  };
  // 升降级
  const handleMageUpgrade = async (
    id,
    val = "",
    email = "",
    social = "",
    am_id = ""
  ) => {
    try {
      let param = {
        package_id: id,
        email: email,
        social: social,
        am_id: am_id,
        is_yearly: !planShow ? 1 : 0,
      };
      if (val && val !== "") {
        param.remark = val;
      }

      let monthList = subList.month;
      let yearList = subList.year;
      monthList.map((item, ind) => {
        if (item.id === id) {
          item.loading = true;
        }
        return item;
      });
      yearList.map((item, ind) => {
        if (item.id === id) {
          item.loading = true;
        }
        return item;
      });
      setSubList((prev) => ({
        ...prev,
        month: monthList,
        year: yearList,
      }));
      setPageLoading(true);
      let res = await reqPostNewSubscribeChange(param);
      if (res.code === "200") {
        if (res?.data?.id !== "") {
          if (id !== 0) {
            monthList.map((item, ind) => {
              item.loading = false;
              return item;
            });
            yearList.map((item, ind) => {
              item.loading = false;
              return item;
            });
            setSubList({
              month: monthList,
              year: yearList,
            });
            toastFun(res.msg);
            setPageLoading(false);
            window.top.location.href = res.data.url;
          } else {
            //降级
            toastFun("Downgraded successfully");
            getSubscribeList();
            const response = await reqGetCurrentStoreInfo();
            if (response.code === "200") {
              let getData = response.data;
              store.dispatch(changePersonLevel({ infoData: getData }, true));
            }
          }
        } else {
          toastFun("Downgraded successfully");
          const response = await reqGetCurrentStoreInfo();
          if (response.code === "200") {
            let getData = response.data;
            store.dispatch(changePersonLevel({ infoData: getData }, true));
          }
          getSubscribeList();
          //降级
        }
      } else {
        setTimeout(() => {
          monthList.map((item, ind) => {
            item.loading = false;
            return item;
          });
          yearList.map((item, ind) => {
            item.loading = false;
            return item;
          });
          setSubList({
            month: monthList,
            year: yearList,
          });
        }, 3000);
        setPageLoading(false);
        toastFun("Something wrong");
      }
    } catch (error) {}
  };
  const levelMap = {
    4: [1, 2, 5],
    1: [2, 5],
    2: [5],
    0: [1, 2, 4, 5],
    5: [],
  };
  // 降级挽留
  const handleDowngradeReminde = (id) => {
    if (currentPlanId === 0) {
      if (id === 5) {
        setPremiumData((prevValue) => ({
          ...prevValue,
          open: true,
          }));
      }else {
        handleMageUpgrade(id);
      }
    } else {
      setDowngradeReminde((prev) => {
        let currentLevel = prev.plan;
        let params = prev;
        // 月降月/年降年/年降月(高级降低级)
        if (levelMap[id].includes(currentLevel)) {
          if (!planShow && !billPlan ) {// 月高级升年低级
            handleMageUpgrade(id); // 直接购买
            params = { ...params, isHeight: false, open: false };
          }else {
            params = { ...params, isHeight: true, open: true };
          }
        } else {
            //月升月/月升年不弹、年降月(低年降高月)弹
          if (billPlan) {
            // 当前为年套餐
            if (planShow) {
              if (id === currentLevel) {// 同级为高降低
                params = { ...params, isHeight: true, open: true };
              }else {
                params = { ...params, isHeight: false, open: true };
              }
            }else {
              if (id === 5) {
                setPremiumData((prevValue) => ({
                  ...prevValue,
                  open: true,
                  }));
              }else {
                handleMageUpgrade(id); // 直接购买
                params = { ...params, isHeight: false, open: false };
              }
            }
          } else {
            if (id === 5) {
              setPremiumData((prevValue) => ({
                ...prevValue,
                open: true,
                }));
            }else {
              handleMageUpgrade(id); // 直接购买
              params = { ...params, isHeight: false, open: false };
            }
          }
        }
        return { ...params, needDown: id };
      });
    }
  };
  // 锚点定位
  const premiumSectionRef = useRef(null);
  const sourcingSectionRef = useRef(null);
  const importSectionRef = useRef(null);
  const location = useLocation();
  const handRefCurrent = () => {
    try {
      const params = new URLSearchParams(location.search);
      const link =  shopify ? refData : params.get("link");
      const ref = shopify ? refData : params.get("ref");
      if (link === "premium" && premiumSectionRef.current) {
        // 滚动到带有ref的锚点位置
        premiumSectionRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center", // 滚动到视图中央
          inline: "center",
        });
      }
      if (ref === "sourcing_id" && sourcingSectionRef.current) {
        // 滚动到带有ref的锚点位置
        sourcingSectionRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center", // 滚动到视图中央
          inline: "center",
        });
      }
      if (ref === "import_id" && importSectionRef.current) {
        // 滚动到带有ref的锚点位置
        importSectionRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "center", // 滚动到视图中央
          inline: "center",
        });
      }
      setTimeout(() => {
        // 清除链接参数
        var currentUrl = window.location.href;
        if (currentUrl.indexOf("?") !== -1) {
          currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
          if (!!(window.history && window.history.pushState)) {
            window.history.pushState({}, 0, currentUrl);
          }
        }
      }, 2000);
    } catch (error) {}
  };

  // 加量包购买
  const handleQuotaBuy = async (package_id, type) => {
    setPageLoading(true);
    try {
      let params = {
        package_id,
        type,
      };
      if (type === 1) {
        //代表是导入加量包购买
        let import_list = importQuotaList.map((item, ind) => {
          if (ind === package_id) {
            item.loading = true;
            return item;
          } else {
            return item;
          }
        });
        setImportQuotaList(import_list);
      } else {
        let sourcing_list = sourcingQuotaList.map((item, ind) => {
          if (ind === package_id) {
            item.loading = true;
            return item;
          } else {
            return item;
          }
        });
        setSourcingQuotaList(sourcing_list);
      }
      let res = await reqPostNewSubscribeAdd(params);
      if (res.code === "200") {
        if (res?.data?.id !== "") {
          if (type === 1) {
            //代表是导入加量包购买
            let import_list = importQuotaList.map((item, ind) => {
              item.loading = false;
              return item;
            });
            setImportQuotaList(import_list);
          } else {
            let sourcing_list = sourcingQuotaList.map((item, ind) => {
              item.loading = false;
              return item;
            });
            setSourcingQuotaList(sourcing_list);
          }
          toastFun(res.msg);
          window.top.location.href = res.data.url;
        }
        toastFun(res.msg);
      } else {
        if (type === 1) {
          //代表是导入加量包购买
          let import_list = importQuotaList.map((item, ind) => {
            item.loading = false;
            return item;
          });
          setImportQuotaList(import_list);
        } else {
          let sourcing_list = sourcingQuotaList.map((item, ind) => {
            item.loading = false;
            return item;
          });
          setSourcingQuotaList(sourcing_list);
        }
        toastFun("Something wrong");
      }
      setPageLoading(false);
    } catch (error) {}
  };
  let isMount = useRef(null);

  useEffect(() => {
    // 如果没有记录初始路径，存储来源路径
    if (!initialPath) {
      store.dispatch(setInitialPath("/admin/dashboard"));
    }
  }, [initialPath]);
  useEffect(() => {
    if (!isMount.current) {
      getSubscribeList();
      if (shopify) {
        if (!window.opener) {
          handleModalCallback('/admin/subscribe','Plan_Page_Modal')
        }
      } 
      
    }
    return () => {
      isMount.current = true;
    };
    // eslint-disable-next-line
  }, []);

  const [toast, setToast] = useState(false); // 提示
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  const initSkeletonPage = (
    <div className="skeleton_page_children">
      <Page breadcrumbs={true} primaryAction fullWidth={true}>
        <Layout>
          <Layout.Section>
            <BlockStack gap={200}>
              <InlineStack gap={400} align="space-between">
                <Box style={{ width: "100px" }}>
                  <SkeletonDisplayText size="medium" />
                </Box>
                <Box style={{ width: "100px" }}>
                  <SkeletonDisplayText size="medium" />
                </Box>
              </InlineStack>
              <Card>
                <BlockStack gap={400}>
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                </BlockStack>
              </Card>
            </BlockStack>
          </Layout.Section>
        </Layout>
      </Page>
    </div>
  );

  // 套餐切换展示
  const handleOptionClick = (index) => {
    if (index !== activeIndex) {
      setActiveIndex(index);
    }else {
      setActiveIndex(index === 0 ? 1 : 0);
    }
  };
  useEffect(() => {
    if (!initPage && optionRef.current) {
      setOptionWidth(optionRef.current.offsetWidth);
    }
    // eslint-disable-next-line
  }, [initPage, optionRef.current,activeIndex]);
  const pageContent = (
    <Page breadcrumbs={true} fullWidth={true}>
      <Box>
        <Box className="new_sub_top">
          <InlineStack gap={200} align="space-between" blockAlign="center">
            <Box className="new_sub_top_title">
            Choose a plan to grow your dropshipping business
            </Box>
            <Box className={`new_sub_top_btn ${activeIndex === 1 ? 'new_sub_top_btn_right_active_mobile' :''}`}>
              <Card padding={200}>
                <InlineStack gap={200}>
                  <Box
                    ref={activeIndex === 0 ? optionRef : null}
                    className={
                      planShow
                        ? "new_sub_top_btn_right new_sub_top_btn_right_active"
                        : "new_sub_top_btn_right"
                    }
                    onClick={() => {
                      handleOptionClick(0)
                      setPlanShow(!planShow);
                      setFeatureStep({
                        step1:0,
                        step2:0,
                        step4:0,
                      })
                    }}
                  >
                    Pay monthly
                  </Box>
                  <Box
                  ref={activeIndex === 1 ? optionRef : null}
                    className={
                      !planShow
                        ? "new_sub_top_btn_right new_sub_top_btn_right_active"
                        : "new_sub_top_btn_right"
                    }
                    onClick={() => {
                      handleOptionClick(1)
                      setPlanShow(!planShow);
                      setFeatureStep({
                        step1:0,
                        step2:0,
                        step4:0,
                      })
                    }}
                  >
                    <InlineStack gap={100}>
                      <span>Pay yearly</span>
                      <Badge tone="info">Save 50%</Badge>
                    </InlineStack>
                  </Box>
                  <div 
                  className={'new_sub_top_btn_right_active_slider'}
                  style={{
                    width: `${optionWidth}px`,
                    transform: `translateX(${activeIndex ? (100% - optionWidth)+3 : 0}px)`
                  }}
                />
                </InlineStack>
              </Card>
            </Box>
          </InlineStack>
        </Box>

        <Box className="new_sub_plan_content">
          <BlockStack gap={500}>
            {currentPlanId === 2 || currentPlanId === 5 ? (
              <Box ref={premiumSectionRef}>
                <PremiumItem
                handleDifferentModalOpen={handleDifferentModalOpen}
                  setPremiumData={setPremiumData}
                  setReminderModal={setReminderModal}
                  handleDowngradeReminde={handleDowngradeReminde}
                  item={
                    planShow
                      ? subList.month.slice(4, 5)[0]
                      : subList.year.slice(4, 5)[0]
                  }
                />
              </Box>
            ) : (
              ""
            )}
            {planShow ? (
              <Box className="new_sub_plan_list">
                {subList.month.slice(0, 4).map((item, ind) => (
                  <Item
                    item={item}
                    featureStep={featureStep}
                    setFeatureStep={setFeatureStep}
                    key={ind}
                    isClock={isClock}
                    shopifyLevel={shopifyLevel}
                    handleOpenModal={handleOpenModal}
                    handleFeed={handleFeed}
                    setReminderModal={setReminderModal}
                    handleDowngradeReminde={handleDowngradeReminde}
                  />
                ))}
              </Box>
            ) : (
              <Box className="new_sub_plan_list">
                {subList.year.slice(0, 4).map((item, ind) => (
                  <Item
                    item={item}
                    featureStep={featureStep}
                    setFeatureStep={setFeatureStep}
                    key={ind}
                    isClock={isClock}
                    shopifyLevel={shopifyLevel}
                    handleOpenModal={handleOpenModal}
                    handleFeed={handleFeed}
                    setReminderModal={setReminderModal}
                    handleDowngradeReminde={handleDowngradeReminde}
                  />
                ))}
              </Box>
            )}

            {
              <Box className="new_sub_plan_feature_list">
                <FeatureList />
              </Box>
            }
            {currentPlanId !== 2 && currentPlanId !== 5 ? (
              <Box ref={premiumSectionRef}>
                <PremiumItem
                handleDifferentModalOpen={handleDifferentModalOpen}
                  setPremiumData={setPremiumData}
                  setReminderModal={setReminderModal}
                  handleDowngradeReminde={handleDowngradeReminde}
                  item={
                    planShow
                      ? subList.month.slice(4, 5)[0]
                      : subList.year.slice(4, 5)[0]
                  }
                />
              </Box>
            ) : (
              ""
            )}
            <Box ref={sourcingSectionRef}>
              <SourcingQuotaList
                handleQuotaBuy={handleQuotaBuy}
                sourcingQuotaList={sourcingQuotaList}
                setSourcingQuotaList={setSourcingQuotaList}
              />
            </Box>
            <Box ref={importSectionRef}>
              <ImportQuotaList
                handleQuotaBuy={handleQuotaBuy}
                importQuotaList={importQuotaList}
                setImportQuotaList={setImportQuotaList}
              />
            </Box>
            <Box>
              <QuestionBox />
            </Box>
          </BlockStack>
        </Box>
      </Box>
    </Page>
  );
  return (
    <div className="new_subscribe_page skeleton_page">
      {pageLoading && <SearchLoading />}
       {initPage && initSkeletonPage}
      <div style={{opacity: initPage ? 0 : 1}}>
        {pageContent}
      </div>
      {toastMarkup}
      <AdditionalBenefitsModal
        upgradeOpen={upgradeOpen}
        setUpgradeOpen={() => setUpgradeOpen(false)}
      />
      <FeedbackOptionModal
        upgradeOpen={feedOptionModal}
        setUpgradeOpen={() => setFeedOptionModal(false)}
        handleMageUpgrade={handleMageUpgrade}
      />
      <PersonalAgentModal
        premiumData={premiumData}
        handlePremiumOff={handlePremiumOff}
        handleMageUpgrade={handleMageUpgrade}
      />
      <ReminderPlanModal open={reminderModal} onClose={setReminderModal} />

      {/* 套餐降级提示 */}
      <DowngradePlanModal
        downgradeReminde={downgradeReminde}
        setDowngradeReminde={setDowngradeReminde}
        handleMageUpgrade={handleMageUpgrade}
        setPremiumData={setPremiumData}
      />
    </div>
  );
};
const importRecharge = [
  {
    price: "10",
    badge: "products",
    symbol: "$",
    desc: "per product",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "30",
    badge: "products",
    symbol: "$",
    desc: "per product",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "50",
    badge: "products",
    symbol: "$",
    desc: "per product",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
];
const sourcingRecharge = [
  {
    price: "15",
    badge: "sourcing requests",
    symbol: "$",
    desc: "per sourcing",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "60",
    badge: "sourcing requests",
    symbol: "$",
    desc: "per sourcing",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "90",
    badge: "sourcing requests",
    symbol: "$",
    desc: "per sourcing",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
];

export default SubscriptionPaidClass;
